import { BottomCurveComponent } from "./components/waves/bottom-curve";
import { BottomWaveComponent } from "./components/waves/bottom-wave";
import { TopWaveComponent } from "./components/waves/top-wave";

export const specificComponents = [
  TopWaveComponent,
  BottomWaveComponent,
  BottomCurveComponent,
]